/**
 * The one place the support address is written down.
 *
 * Hoisted here on its SECOND site (§36). It was a file-local const in
 * `PublicHelpPage`, and VRG-595 needed it twice more on the signup page — a
 * third hand-typed copy of an address is exactly the shape that drifts, and an
 * address that drifts is mail nobody receives.
 *
 * Rendered as the LINK TEXT, not behind words like "contact us": `mailto:` does
 * nothing for a reader on webmail with no mail client registered, and when it
 * does nothing the address itself has to still be on the page, readable and
 * selectable. So call sites read `Email {SUPPORT_EMAIL}`, never
 * `<a href={SUPPORT_MAILTO}>contact us</a>`.
 *
 * ⚠️ This is the CLIENT's copy, and there is a second one. It mirrors
 * `SUPPORT_INTERNAL_EMAIL`'s default in `apps/api/src/config/app.ts` — the
 * address every support notification is already delivered to. The two cannot be
 * shared through a package (the API's is server-side config, overridable per
 * environment), so changing one means changing both. Carried over from
 * `PublicHelpPage`, which is where this constant used to live.
 */
export const SUPPORT_EMAIL = 'support@vera.inc'

/** `href` form of {@link SUPPORT_EMAIL}. */
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`
